import React from 'react'

import AuthContext from 'contexts/AuthContext'

const useAuth = () => {
  const context = React.useContext(AuthContext)

  if (!context) {
    return null
  }

  return {
    isLoading: context.isLoading,
    loaded: context.loaded,
    user: context.user,
    seller: context.seller,
    permissions: context.permissions,
    loadData: context.loadData,
    checkMainRoute: context.checkMainRoute,
    resetAuthData: context.resetAuthData,
    login: context.login,
    logout: context.logout,
  }
}

export default useAuth
